var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.5,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.067 14.77c-.59 0-1.067.477-1.067 1.066v3.2a4.267 4.267 0 004.267 4.267H19.2a4.267 4.267 0 004.267-4.267v-3.2a1.067 1.067 0 00-2.134 0v3.2a2.133 2.133 0 01-2.133 2.133H4.267a2.134 2.134 0 01-2.134-2.133v-3.2c0-.589-.478-1.067-1.066-1.067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.828 17.958c.59 0 1.067-.477 1.067-1.066V3.558l2.464 2.358a1.065 1.065 0 001.508.03c.425-.407.44-1.083.031-1.508-.021-.022-.044-.043-.067-.064L12.564.294a1.068 1.068 0 00-1.472 0l-4.266 4.08a1.066 1.066 0 101.472 1.542l2.464-2.347v13.333a1.066 1.066 0 001.066 1.056"
  }))));
};

export default SvgUpload;